import { CanActivateFn } from '@angular/router';

import { stashPendingEntityRelationshipIdFromLocation } from '@shared/utils';

/**
 * Captures a pending entity relationship id from the URL before Auth0 may
 * redirect and drop the query string on cross-tenant hops.
 */
export const stashPendingEntityRelationshipGuard: CanActivateFn = () => {
  stashPendingEntityRelationshipIdFromLocation();
  return true;
};
